import { Content } from './picture.styled';

export const Picture = ({ fn, name }) => {
  return (
    <Content>
      <img src={fn} alt={name} />
    </Content>
  );
};
